export const getFlags = (bank = {}) => {
  const flags = bank?.flags
  const flagLabels = bank?.flagLabels
  if (!bank || !flags || !flagLabels) {
    return []
  }
  return Object.entries(flags).reduce((acc, [k, v]) => {
    if (v && bank?.flagLabels?.[k]) {
      acc.push({ label: flagLabels[k], name: k })
    }
    return acc
  }, [])
}
